import { useState, useMemo } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/apiClient";
import { KeyRound, ArrowLeft, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token") || "", [params]);
  const navigate = useNavigate();
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw1.length < 6) { toast.error("Mínimo 6 caracteres"); return; }
    if (pw1 !== pw2) { toast.error("As palavras-passe não coincidem"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw1 });
      toast.success("Palavra-passe atualizada. Já podes entrar.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4">
      <div className="w-full max-w-sm" data-testid="reset-page">
        <Link to="/login" className="inline-flex items-center gap-1 text-xs text-[#A3A3A3] hover:text-white uppercase tracking-widest font-bold mb-4" data-testid="reset-back">
          <ArrowLeft className="w-3 h-3" /> Voltar ao login
        </Link>
        {!token ? (
          <div className="kw-card p-8 text-center kw-fade-up" data-testid="reset-no-token">
            <AlertTriangle className="w-10 h-10 text-[#FFB020] mx-auto mb-3" />
            <h1 className="font-display text-2xl font-black uppercase mb-2">Link inválido</h1>
            <p className="text-sm text-[#A3A3A3]">Não recebemos um token de reset. Volta a pedir um novo link.</p>
            <Link to="/forgot-password" className="kw-btn-secondary inline-block mt-5">Pedir novo link</Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="kw-card p-8 kw-fade-up" data-testid="reset-form">
            <div className="flex items-center gap-2 mb-4">
              <KeyRound className="w-5 h-5 text-[#E50000]" />
              <div className="kw-overline">Nova palavra-passe</div>
            </div>
            <h1 className="font-display text-3xl font-black uppercase mb-5">Definir Nova Password</h1>
            <label className="kw-overline block mb-2">Nova palavra-passe</label>
            <input type="password" required autoFocus minLength={6} className="kw-input mb-3" value={pw1}
              placeholder="Mínimo 6 caracteres"
              onChange={(e) => setPw1(e.target.value)} data-testid="reset-pw1" />
            <label className="kw-overline block mb-2">Confirmar palavra-passe</label>
            <input type="password" required minLength={6} className="kw-input mb-4" value={pw2}
              placeholder="Repete a palavra-passe"
              onChange={(e) => setPw2(e.target.value)} data-testid="reset-pw2" />
            <button type="submit" disabled={loading} className="kw-btn-primary w-full" data-testid="reset-submit">
              {loading ? "A atualizar…" : "Atualizar palavra-passe"}
            </button>
            <p className="text-[10px] text-[#737373] uppercase tracking-widest mt-4 text-center">
              O link expira em 1 hora · uso único
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
